<template>
    <transition name="modal-fade">
        <div
            class="modal-backdrop"
            @click="closeOnOutsideClick"
        >
            <div
                :class="['modal',
                         displaySmallOrExtraSmall ? 'modal-small' : '' ]"
            >
                <component
                    :is="modalComponentName"
                    :component-name-is-set="modalComponentNameIsSet"
                />
            </div>
        </div>
    </transition>
</template>

<script lang="ts">
    import { Component, Vue } from "vue-facing-decorator"
    import LisatiedotKunnanLaajakaistaliittymistaModal from "@/views/Viestinta/LaajakaistaJaPuhelin/Modals/LisatiedotKunnanLaajakaistaliittymistaModal.vue"
    import LisatiedotKunnanMobiililiittymistaModal from "@/views/Viestinta/LaajakaistaJaPuhelin/Modals/LisatiedotKunnanMobiililiittymistaModal.vue"
    import LaajakaistahankkeetModal from "@/views/Viestinta/LaajakaistaJaPuhelin/Modals/LaajakaistahankkeetModal.vue"
    import AntenniTVSaatavuusModal from "@/views/Viestinta/TVJaRadio/Modals/AntenniTVSaatavuusModal.vue"
    import ViatJaHairiotModal from "@/views/Viestinta/ViatJaHairiot/Modals/ViatJaHairiotModal.vue"
    import PostitoimipisteetModal from "@/views/Viestinta/Posti/Modals/PostitoimipisteetModal.vue"
    import LupaJaRekisterointitoimipaikatModal from "@/views/Liikenne/Tieliikenne/Modals/LupaJaRekisterointitoimipaikat.vue"
    import RekisterointitoimipaikatModal from "@/views/Liikenne/Vesiliikenne/Modals/Rekisterointitoimipaikat.vue"
    import TietoaSivustostaModal from "@/views/Modals/TietoaSivustosta.vue"
    import SivukarttaModal from "@/views/Modals/Sivukartta.vue"

    const COMPONENT_MAPPING = {
        LisatiedotKunnanLaajakaistaliittymistaModal,
        LisatiedotKunnanMobiililiittymistaModal,
        LaajakaistahankkeetModal,
        AntenniTVSaatavuusModal,
        ViatJaHairiotModal,
        PostitoimipisteetModal,
        LupaJaRekisterointitoimipaikatModal,
        RekisterointitoimipaikatModal,
        TietoaSivustostaModal,
        SivukarttaModal
    }

    @Component({
        components: {
            LisatiedotKunnanLaajakaistaliittymistaModal,
            LisatiedotKunnanMobiililiittymistaModal,
            LaajakaistahankkeetModal,
            AntenniTVSaatavuusModal,
            ViatJaHairiotModal,
            PostitoimipisteetModal,
            RekisterointitoimipaikatModal,
            LupaJaRekisterointitoimipaikatModal,
            TietoaSivustostaModal,
            SivukarttaModal
        }
    })
    export default class Modal extends Vue {
        get modalComponentName(): string {
            if (COMPONENT_MAPPING[this.$store.getters.modalComponentName]) {
                return this.$store.getters.modalComponentName
            }
            else {
                // TODO OKo: Tänne ei pitäisi päätyä, koska koodaajan pitäisi varmistua että store päivitetty ennen kuin avaus-nappi näkyvissä
                // TODO OKo: Pitäisikö tehdä modalin avausnappia varten komponentti, johon olisi pakotettuna propertynä avattavan modal-kompoentin nimi
                return this.$store.getters.modalComponentName
            }
        }

        // ruutukoko
        get displayType(): string {
            return this.$store.getters.displayType
        }

        get displayLarge(): string {
            return this.$store.state.displayLarge
        }

        get displayExtraLarge(): string {
            return this.$store.state.displayExtraLarge
        }

        get displayMedium(): string {
            return this.$store.state.displayMedium
        }

        get displaySmall(): string {
            return this.$store.state.displaySmall
        }

        get displayExtraSmall(): string {
            return this.$store.state.displayExtraSmall
        }

        // ruutukoko on pienempi kuin medium
        get displaySmallOrExtraSmall(): boolean {
            return this.displayType === this.displaySmall || this.displayType === this.displayExtraSmall
        }

        get modalComponentNameIsSet(): boolean {
            if (this.modalComponentName) {
                return true
            }
            return false
        }

        closeOnOutsideClick(event): void {
            if (event.target.className === "modal-backdrop") {
                this.$store.dispatch("setModalComponentName", "")
            }
        }
    }
</script>

<style scoped>
    .modal-fade-enter-from,
    .modal-fade-leave-active {
        opacity: 0;
    }

    .modal-fade-enter-active,
    .modal-fade-leave-active {
        transition: opacity .5s ease
    }

    .modal-backdrop {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.3);
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .modal {
        background: #FFFFFF;
        box-shadow: 2px 2px 20px 1px;
        overflow-x: auto;
        display: flex;
        flex-direction: column;
        left: 25%;
        right: 25%;
        width: auto;
        height: 100%;
        top: 0%;
        bottom: 0%;
        z-index: 100;
    }

        .modal.modal-small {
            left: 0;
            right: 0;
            width: 100%;
            height: 100%;
            top: 0;
            bottom: 0;
        }

    .modal-header,
    .modal-footer {
        padding: 15px;
        display: flex;
    }

    .modal-header {
        justify-content: space-between;
    }

        .modal-header .header-namelabel {
            width: 55%;
            margin-left: 15px;
        }

        .modal-header .header-updatelabel {
            margin-top: 23px;
            width: 45%;
            text-align: right;
            margin-right: 5px;
        }

    .modal-footer {
        justify-content: flex-end;
    }

    .modal-body {
        position: relative;
        padding: 20px 30px;
        overflow-y: auto;
    }

    .margin-top {
        margin-top: 15px;
    }

    .btn-close {
        border: none;
        font-size: 1.5rem;
        padding: 15px 20px;
        cursor: pointer;
        font-weight: bold;
        background: transparent;
    }

    .sensorTypeSpan {
        display: block;
        margin-right: 10px;
    }

    .modal-custom-row {
        margin-bottom: 5px;
    }

        .modal-custom-row div:first-of-type {
            font-weight: 600;
        }

    .refresh-button {
        margin-top: 16px;
    }

    .disturbance-data {
        margin-bottom: 15px;
    }

    .show-details {
        margin-bottom: 5px;
    }
</style>
